import { Stack } from '@mantine/core';
import { RunMetadataStep } from '@/types/automationSteps.ts';
import StepCommonFields from '@/pages/Editor/components/SharedFields/StepCommonFields.tsx';
import OutputNameField from '@/pages/Editor/components/SharedFields/OutputNameField.tsx';
import StepAdvancedConfigFields from '@/pages/Editor/components/SharedFields/StepAdvancedConfigFields.tsx';

type props = {
  step: RunMetadataStep;
};

export function RunMetadataForm({ step }: props) {
  return (
    <Stack gap="md">
      <StepCommonFields step={step} nameLabel="Step Name" />
      <OutputNameField step={step} />
      <StepAdvancedConfigFields step={step} />
    </Stack>
  );
}
